import { useQuery } from '@apollo/client';
import { useRouter } from 'next/compat/router';

import { CheckoutDocument } from 'src/gql/graphql';
import { useExternalUserDetails } from './hooks/use-external-user-details';
import { hasPlusRedirectSucceeded } from '../plus-redirect-state';

export default function useCartDataFromServer(dispensary) {
  const router = useRouter();
  const { checkoutId, dispensaryId } = router?.query ?? {};

  const { data, error } = useQuery(CheckoutDocument, {
    skip: !checkoutId || !dispensaryId,
    variables: { checkoutId, dispensaryId },
  });

  useExternalUserDetails();

  // The order was already successfully placed and its own redirect (with `orderNumber`) already
  // fired -- don't let a late/racing getCheckout error clobber it with `checkoutError=NOT_FOUND`.
  if (error && !hasPlusRedirectSucceeded()) {
    const plusDefaultReturnUrl = dispensary?.plusSettings?.defaultReturnUrl;

    if (!plusDefaultReturnUrl) {
      console.error(`No return url found`);
    } else {
      const redirectUrl = `${plusDefaultReturnUrl}?checkoutError=NOT_FOUND`;
      window.location.href = redirectUrl;
      return null;
    }
  }

  return data?.getCheckout;
}
